import React, { useEffect, useState } from "react";
import DescriptionCard from "./DescriptionCard";
import CryptoHuntTile from "./CryptoHuntTile";

const CryptoHuntHomeIntro = ({ isActive }) => {
  const words = ["MATIC", "SBONK", "SHIBA"];
  const [renderKey, setRenderKey] = useState(0);

  const getBackgroundColor = (word, char, charIndex) => {
    if (word === "MATIC") {
      if (char === "A" || char === "I") return "bg-yellow-500";
      return "bg-gray-600";
    }
    if (word === "SBONK") {
      if (char === "S") return "bg-green-500";
      if (char === "B") return "bg-yellow-500";
      return "bg-gray-600";
    }
    if (word === "SHIBA") {
      return "bg-green-500";
    }
    return "bg-[#000]";
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setRenderKey((prev) => prev + 1);
    }, 9000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {isActive ? (
        <div className="flex flex-col xl:gap-y-8 sm:gap-y-6 gap-y-4 lg:items-start items-center w-full">
          <p className="xl:text-2xl md:text-xl xs:text-base text-[13px] lg:text-left text-center font-normal">
            Test your crypto knowledge by hunting words
          </p>
          <DescriptionCard />

          <div
            key={renderKey}
            className="flex flex-col lg:items-start items-center w-full 2xl:gap-y-4 xl:gap-y-3 xs:gap-y-2 gap-y-1"
          >
            {words.map((word, wordIndex) => (
              <div
                key={wordIndex}
                className="flex flex-row items-center 2xl:gap-x-4 xl:gap-x-3 xs:gap-x-2 gap-x-1"
              >
                {word.split("").map((char, charIndex) => (
                  <CryptoHuntTile
                    char={char}
                    key={charIndex}
                    index={charIndex + wordIndex * word.length}
                    className={getBackgroundColor(word, char, charIndex)}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CryptoHuntHomeIntro;
